/* eslint-disable max-len */
import * as React from 'react';

import { colors } from 'theme/colors';

export function WarningToast(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5Z" fill={colors.warning.main} />
      <path d="M13 16.5H11V18.5H13V16.5Z" fill={colors.warning.main} />
      <path d="M13 10.5H11V15.5H13V10.5Z" fill={colors.warning.main} />
    </svg>
  );
}
